import script from "./DownloadPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadPage.vue?vue&type=script&setup=true&lang=js"

import "./DownloadPage.vue?vue&type=style&index=0&id=247d4e08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-247d4e08"]])

export default __exports__